import { render, staticRenderFns } from "./EventDialogComponent.vue?vue&type=template&id=2304da36&scoped=true"
import script from "./EventDialogComponent.js?vue&type=script&lang=js&external"
export * from "./EventDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./EventDialogComponent.vue?vue&type=style&index=0&id=2304da36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304da36",
  null
  
)

export default component.exports